import { render } from "./AppTopbar.vue?vue&type=template&id=34a70f6a"
import script from "./AppTopbar.vue?vue&type=script&lang=js"
export * from "./AppTopbar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__